<template>
  <hic-dialog append-to-body :close-on-click-modal="false" :visible="visible" width="60rem" @open="open" :title="entity.id ? '编辑班次系列' : '新建班次系列'" @close="cancel">
    <el-form :model="entity" :rules="rules" ref="editor" label-width="7rem" :inline="true">
      <el-row>
        <el-col :span="12">
          <el-form-item label="系列名称" prop="name">
            <el-input v-model.trim="entity.name" placeholder="请输入班次系列名称" style="width: 200px"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="人员类型" prop="staffTypeCode">
            <el-select v-model="entity.staffTypeCode" placeholder="请选择类型" style="width: 200px">
              <el-option v-for="t in staffTypes" :key="t.code" :label="t.name" :value="t.code"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      
      <div style="margin-top: 15px; margin-bottom: 10px;">
        <span style="font-weight: bold; margin-right: 15px;">班次序列设置</span>
        <el-button type="success" size="mini" icon="el-icon-plus" @click="addShift" circle plain></el-button>
      </div>
      
      <el-table :data="entity.items" border style="width: 100%" size="small" empty-text="暂未配置班次">
        <el-table-column label="顺序序号" type="index" width="80" align="center"></el-table-column>
        <el-table-column label="班次类型" min-width="150" align="center">
          <template slot-scope="{ row }">
            <el-select v-model="row.shiftTypeId" size="mini" style="width: 90%" placeholder="选择班次">
              <el-option v-for="s in shiftTypes" :key="s.id" :label="s.name" :value="s.id">
                <span style="float: left">{{ s.name }}</span>
                <span style="float: right; width: 15px; height: 15px; border-radius: 2px" :style="{ backgroundColor: s.color }"></span>
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" icon="el-icon-delete" circle plain @click="removeShift(scope.$index)"></el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="save" :loading="saving">确 定</el-button>
    </div>
  </hic-dialog>
</template>

<script>
import api from '@/common/api'
import { mapGetters } from "sw-hic";

export default {
  props: {
    visible: Boolean,
    entity: Object
  },
  data() {
    return {
      saving: false,
      staffTypes: [],
      shiftTypes: [],
      rules: {
        name: [
          { required: true, message: '请输入系列名称', trigger: 'blur' },
          { max: 40, message: '名称长度在 40 个字符以内', trigger: 'blur' }
        ],
        staffTypeCode: [
          { required: true, message: '请选择人员类型', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters(["permission", "dict", "user"]),
    
  },
  mounted() {
    this.loadMeta()
  },
  methods: {
    loadMeta() {
      this.staffTypes = this.dict.TitleType
      api.ShiftType.query({ pageSize: 999 }).then(res => {
        this.shiftTypes = res.items
      })
    },
    open() {
      if (this.$refs.editor) {
        this.$refs.editor.clearValidate()
      }
      if (!this.entity.items) {
        this.$set(this.entity, 'items', [])
      }
    },
    cancel() {
      this.$emit('update:visible', false)
    },
    addShift() {
      if (!this.entity.items) {
        this.$set(this.entity, 'items', [])
      }
      this.entity.items.push({
        seriesId: this.entity.id,
        shiftTypeId: null,
      })
    },
    removeShift(index) {
      this.entity.items.splice(index, 1)
    },
    save() {
      this.$refs.editor.validate((valid) => {
        if (valid) {
          // Validation for empty items or missing shiftTypeId
          if (this.entity.items.some(item => !item.shiftTypeId)) {
            this.$message.warning('有未选择班次的行，请选择或删除')
            return
          }
          
          this.saving = true
          
          // Generate sequential seqNo before saving
          this.entity.items.forEach((item, index) => {
            item.seqNo = index + 1
          })
          
          api.ShiftTypeSeries.save(this.entity).then(res => {
            this.$message.success('保存成功')
            this.$emit('update:visible', false)
            this.$emit('ok', res)
          }).catch(err => {
            this.$message.error('保存失败: ' + err)
          }).finally(() => {
            this.saving = false
          })
        }
      })
    }
  }
}
</script>
